export const getStaticMapTheme = (themeArray: any[]) => {
    if (!themeArray.length) {
      return "";
    }
    let theme = "";
    themeArray.forEach((style: { [key: string]: any }) => {
      theme += `&style=feature:${style.featureType}|element:${
        style.elementType
      }|${style.stylers
        .map((style: object) => {
          for (const [key, value] of Object.entries(style)) {
            if (key === "color") {
              return `${key}:${value.replace("#", "0x")}`;
            }
            return `${key}:${value}`;
          }
        })
        .join("|")}`;
    });
    return theme;
  };